module.exports = __webpack_public_path__ + "static/media/ccb_img1.dd631541.jpg";